import React from 'react';
import {Link} from '../../raw-components/link/link';
import {FilterLinkIconBox} from "./boxes/icon/filter-link-icon.box";
import {ACTIVE} from "../../../themes/css-global-classes";
import classNames from "classnames";
import {observer} from "mobx-react";
import {FilterLinkBox} from "./boxes/filter-link.box";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {
  IArenaGameFilterEditorViewModel
} from "../../../services/games-filter/arena-filters/filters/arena-game-filter-editor-view-model.interface";

export interface FilterLinkComponentProps {
  filter: IArenaGameFilterEditorViewModel,
  onChange: (filter: IArenaGameFilterEditorViewModel) => void;
}

export const FilterLinkComponent = observer(
  class FilterLinkComponent extends OrbitComponent<FilterLinkComponentProps> {

    private _onFilterClick = () => {
      this.props.onChange(this.props.filter);
    };

    render() {
      return (
          <Link box={FilterLinkBox} className={classNames('cy-filter-link',{[ACTIVE]: this.props.filter.on})} onClick={this._onFilterClick}>
              <FilterLinkIconBox className={'cy-filter-link-icon'}></FilterLinkIconBox>
              {this.props.filter.text}
          </Link>
      );
    }
  }
);
